export default __webpack_public_path__ + "static/media/graz2_dark.e29bf3b4.png";